import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const NotFound = Loadable(lazy(() => import('./NotFound')));
const EmailValidate = Loadable(lazy(() => import('./EmailValidate')));

const sessionRoutes = [
  { path: '/session/404', element: <NotFound /> },
  { path: `/mailbox/:token`, element: <EmailValidate /> },
];

export default sessionRoutes;
